import { render, staticRenderFns } from "./headerModal.vue?vue&type=template&id=7c9b5f8e&scoped=true&"
import script from "./headerModal.vue?vue&type=script&lang=ts&"
export * from "./headerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9b5f8e",
  null
  
)

export default component.exports